module.exports = __webpack_public_path__ + "img/participation.984805af.svg";